// @owners { team: patient-fulfillment }
import { push } from 'react-router-redux';
import { openModal } from '~shared/actions/modal';
import { selectPrescription } from '~shared/actions/prescriptions';
import {
  getFormattedDeliveryDateForAutoRefillPrescriptions,
  getMedsWithAutoRefill,
} from '~shared/features/auto-refill/selectors/getMedsWithAutoRefill';
import { sendAnalyticsEvent } from '~shared/lib/analytics/src/actions';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { createEvent } from '~shared/lib/analytics/src/helper';
import { connect } from '~shared/store';
import { type ReduxDispatchShared, type ReduxStateShared } from '~shared/types';
import ProfileAutoRefills from './ProfileAutoRefills';

function mapStateToProps(state: ReduxStateShared) {
  const medicationsWithAutoRefills = getMedsWithAutoRefill(state);
  const deliveryDatesByPrescriptionID = getFormattedDeliveryDateForAutoRefillPrescriptions(state);

  return {
    medicationsWithAutoRefills,
    deliveryDatesByPrescriptionID,
  };
}

const mapDispatchToProps = (dispatch: ReduxDispatchShared) => {
  return {
    navigateToMedList: () => {
      dispatch(push('/prescriptions'));
    },
    openAutoRefillOffModal: (prescriptionId: number) => {
      dispatch(openModal('AUTO_REFILL'));
      dispatch(selectPrescription(prescriptionId));
    },
    trackProfileAutoRefillsViewed: () => {
      dispatch(sendAnalyticsEvent(createEvent(EVENTS.AUTO_REFILL_MANAGEMENT_CENTER_VIEWED)));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileAutoRefills);
